import type { DeepPartial } from '@luna/utils-ts';
import type { StatementDisplayType } from '@retail/investments-types';

import type { Statements } from '../../types/Statements';

export const statementsSKFeatureConfig: DeepPartial<Statements> = {
    hasPaging: true,
    sendStatementIdAsQueryParam: true,
    showCoreStatements: true,
    supportedStatementTypes: ['ALL', 'PORTFOLIO', 'CONFIRMATIONS'] as StatementDisplayType[],
};
